module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0152.jpg?v=fc34a15e";